export default __webpack_public_path__ + "static/media/razorpay-logo.5cdb58df 1.6a67c7eb.svg";